import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-fa5352e4")
const _hoisted_1 = { class: "plastic-source-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "titles medi-font" }, [
  /*#__PURE__*/_createElementVNode("span", null, "极农（XFarmer）----小农产业数字化平台")
], -1)
const _hoisted_3 = {
  class: "head",
  ref: "card"
}
const _hoisted_4 = { class: "head-top" }
const _hoisted_5 = { class: "title lager-font" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 631@2x.png",
  class: "connect"
}, null, -1)
const _hoisted_7 = { class: "head-bottom" }
const _hoisted_8 = {
  key: 0,
  class: "text litt-font"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "产地：", -1)
const _hoisted_10 = {
  key: 1,
  class: "text litt-font"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "品种：", -1)
const _hoisted_12 = {
  key: 2,
  class: "text litt-font"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "储存：", -1)
const _hoisted_14 = {
  key: 3,
  class: "text litt-font"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "title-name" }, "产品特点：", -1)
const _hoisted_16 = { class: "verifyy-play" }
const _hoisted_17 = { class: "code-input" }
const _hoisted_18 = { class: "code-input" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "code-text" }, [
  /*#__PURE__*/_createElementVNode("div", null, " 1、将产品上的防伪溯源标签涂层刮开，查看防伪码，将防伪码输入上方输入框； "),
  /*#__PURE__*/_createElementVNode("div", null, " 2、若您输入的防伪码正确且为首次查询，系统会提示“该防伪码为真，且第一次被查询，经判定为正品”； "),
  /*#__PURE__*/_createElementVNode("div", null, " 3、若您输入的防伪码正确但非首次查询，系统会提示“该防伪码已被XX次查询，谨防假冒！” "),
  /*#__PURE__*/_createElementVNode("div", null, " 4、若您输入的防伪溯源码错误，系统会提示“防伪码错误，谨防假冒！！” ")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_image, {
          width: "21.5625rem",
          height: "12.8125rem",
          fit: "cover",
          src: _ctx.dataInfo.productImg
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.dataInfo.productName), 1)
      ]),
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_ctx.dataInfo.cityName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.cityName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataInfo.typeName)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.typeName), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataInfo.store)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.store), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.dataInfo.productInfo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createTextVNode(_toDisplayString(_ctx.dataInfo.productInfo), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_van_image, {
        class: "verify-img",
        src: "https://qnui.xfarmer.com/xfarmer-ui/trace/verify.png"
      }),
      _createVNode(_component_van_image, {
        class: "down",
        src: "https://qnui.xfarmer.com/xfarmer-ui/trace/down.png"
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.password = $event)),
        placeholder: "请在这里输入防伪码"
      }, null, 512), [
        [_vModelText, _ctx.password]
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onVerify && _ctx.onVerify(...args)))
      }, "验证真伪")
    ]),
    _hoisted_19
  ]))
}